/**
 * Employee Web — root route.
 *
 * Declares the typed RouterContext so every child loader can read
 * `context.auth.getSnapshot()` without prop-drilling. The context is supplied
 * by createAppRoot (main.tsx) at createRouter call time.
 *
 * `<Toaster>` is mounted here so unauth routes (`/auth/invite`, `/auth/reset`,
 * `/auth/forgot`, `/login`) inherit `useToast()` context — without this hoist,
 * `InviteAcceptForm` and `ResetCompleteForm` crash with "useToast must be used
 * inside <Toaster>" before the form ever renders. Authenticated routes inherit
 * the same provider transparently; the prior wrapper inside `_auth.tsx` is
 * therefore redundant and was removed.
 */
import type { JSX } from "react";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "@linkhr/design-system";
import type { RouterContext } from "@linkhr/auth";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootComponent,
});

function RootComponent(): JSX.Element {
  return (
    <Toaster>
      <Outlet />
    </Toaster>
  );
}
